import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { Store } from '../../../../store';
import { OverlayService } from '../../../../services/overlay.service';

@Component({
    selector: 'app-product-details-description',
    templateUrl: './product-details-description.component.html',
    styleUrls: ['./product-details-description.component.scss'],
})
export class ProductDetailsDescriptionComponent {
    @Input() product;
    @ViewChild('scrollTabAnchor') scrollTabAnchor: ElementRef;
    deviceType$ = this.store.select<string>('deviceType');
    deviceType = this.store.selectForLocal('deviceType');
    settings$ = this.store.select<any>('settings');
    navTab = 'description';

    constructor(private store: Store, private overlayService: OverlayService) {
        if (this.deviceType && this.deviceType === 'mobile') {
            this.navTab = '';
        }
    }

    setNavTab(v) {
        if (this.navTab === v) {
            this.navTab = '';
        } else {
            this.navTab = v;
            const top = this.scrollTabAnchor.nativeElement.getBoundingClientRect().top + window.scrollY - 200;
            window.scrollTo({
                top,
                behavior: 'smooth',
            });
        }
    }

    viewColourVariations() {
        this.store.set('product', this.product);
        this.overlayService.toggle('colourVariationsModal');
    }
}
